import React from 'react'
import "../App.css"
import {Features,Header,Possibility,WhatWoix} from "../containers";
import {Brand} from "../components";

function Home() {
  return (
    <div className="App"> 
     <Header/>      
      <Brand/>
      <WhatWoix/>
      <Features/>
      <Possibility/>
     </div>
  );
}

export default Home;